import { routes } from "@/router";
import { useTranslation } from "react-i18next";
import { HiFire, HiOutlineSparkles } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import Button from "@/components/atoms/Button";
import SubscriptionItemFeature from "@/components/molecules/subscription/SubscriptionItemFeature";

const SubscriptionEnterprise = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div
        className={
          "rounded-2xl bg-gradient-to-r from-[var(--brand-primary-700)] to-[var(--brand-primary-500)] shadow-md"
        }
      >
        <div className={"p-7 text-white"}>
          <div className={"flex justify-between"}>
            <div className={"flex flex-col gap-2"}>
              <h4 className={"text-xl font-semibold"}>{t("settings.plans.predictiveLeads")}</h4>
              <p className="text-4xl font-bold">
                €189.00<span className="text-sm font-normal">/ per month; billed quarterly</span>
              </p>
              <p className="text-sm font-normal">
                <span className="font-medium">€239.00</span> billed monthly
              </p>
            </div>

            <HiOutlineSparkles className={"size-10"} />
          </div>
        </div>

        <div className={"rounded-2xl border bg-white px-4 pb-6 pt-8"}>
          <div className={"grid grid-cols-2 gap-x-3 xl:grid-cols-4"}>
            <div className={"col-span-2 pr-20"}>
              <h5 className={"mb-1.5 text-xl font-semibold text-primary"}>{t("settings.plans.enterprise.heading")}</h5>
              <p className={"mb-8 text-sm text-quaternary"}>{t("settings.plans.enterprise.description")}</p>
              <div className={"hidden pb-3 lg:inline-flex xl:pb-0"}>
                <Button
                  label={t("settings.plans.enterprise.button")}
                  size={"sm"}
                  onClick={() => navigate(routes.predictive)}
                />
              </div>
            </div>

            <div className={"col-span-2 lg:col-span-1"}>
              <SubscriptionItemFeature icon={<HiFire className="size-3" />}>
                <div className="ml-1 text-sm font-semibold text-brand-primary">
                  {t("settings.plans.perks.personalizedPredictiveLeads")}
                </div>
              </SubscriptionItemFeature>
              <SubscriptionItemFeature text={t("settings.plans.perks.highConversionLeads")} />
              <SubscriptionItemFeature text={t("settings.plans.perks.reviewedByExperts")} />
            </div>

            <div className={"col-span-2 lg:col-span-1"}>
              <SubscriptionItemFeature text={t("settings.plans.perks.biWeeklyCalls")} />
              <SubscriptionItemFeature text={t("settings.plans.perks.aiLearns")} />
              <SubscriptionItemFeature text={t("settings.plans.perks.patternAnalysis")} />
            </div>

            <Button
              label={t("settings.plans.enterprise.button")}
              size={"sm"}
              className={"col-span-2 mt-3 lg:hidden"}
              onClick={() => navigate(routes.predictive)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionEnterprise;
